var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrief = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 16,
  viewBox: "0 0 14 16",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 2v12h10v1c0 .552-.456 1-1.002 1H1.002C.45 16 0 15.55 0 14.993V3.007C0 2.45.444 2 1 2zm7-2 5 4.667v7.328A1 1 0 0 1 13.004 13H3.996A.997.997 0 0 1 3 12.001V1A1 1 0 0 1 3.99 0zM8 1H7v4.002A2 2 0 0 0 8.998 7H13V6H9c-.552 0-1-.444-1-1z"
})));
export default SvgBrief;